import React from 'react';
import { Link } from 'react-router-dom';
import { FaBuilding, FaShop, FaWarehouse, FaCheckCircle, FaRupeeSign } from 'react-icons/fa';

const HomePage = () => {
  return (
    <div className="App">
      {/* Hero Section */}
      <section style={{ background: 'linear-gradient(to right, #2563eb, #003d66)' }} className="text-white py-20">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-6">CoSpace Digital Space Renting Platform</h1>
          <p className="text-xl mb-8">Have unused space in front of your shop? Looking for affordable business space?</p>
          <p className="text-2xl mb-10 font-semibold">CoSpace is the solution!</p>
          <Link to="/spaces" className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition">
            Get Started
          </Link>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12">
            {/* For Space Owners */}
            <div className="bg-blue-50 p-8 rounded-lg">
              <h2 className="text-3xl font-bold mb-6 text-blue-800">FOR SPACE OWNERS</h2>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <FaCheckCircle className="text-orange-500 mr-3 mt-1" />
                  <span className="text-lg">Earn extra income</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-orange-500 mr-3 mt-1" />
                  <span className="text-lg">Daily or monthly rent</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-orange-500 mr-3 mt-1" />
                  <span className="text-lg">Genuine customers</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-orange-500 mr-3 mt-1" />
                  <span className="text-lg">Free space listing</span>
                </li>
              </ul>
            </div>

            {/* For Space Seekers */}
            <div className="bg-blue-50 p-8 rounded-lg">
              <h2 className="text-3xl font-bold mb-6 text-blue-800">FOR SPACE SEEKERS</h2>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <FaCheckCircle className="text-orange-500 mr-3 mt-1" />
                  <span className="text-lg">Prime locations</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-orange-500 mr-3 mt-1" />
                  <span className="text-lg">Low rent</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-orange-500 mr-3 mt-1" />
                  <span className="text-lg">Direct owner contact</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-orange-500 mr-3 mt-1" />
                  <span className="text-lg">Verified listings</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Marketing Opportunity Banner */}
      <section className="bg-gradient-to-r from-orange-400 to-yellow-500 py-12">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">MARKETING EXECUTIVES - JOB OPPORTUNITY</h2>
          <div className="flex justify-center items-center space-x-8 text-white text-lg">
            <div className="flex items-center">
              <FaRupeeSign className="mr-2" />
              <span className="font-bold">10,000 ~ 20,000</span>
            </div>
            <span>VERSIKOT (EKMORA)</span>
            <span>Location-based work</span>
            <span>Performance-based income</span>
          </div>
        </div>
      </section>

      {/* Secure Payments & Get Started */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12">
            {/* Secure Payments */}
            <div>
              <h2 className="text-3xl font-bold mb-6 text-blue-800">Secure Payments</h2>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <FaCheckCircle className="text-orange-500 mr-3 mt-1" />
                  <span className="text-lg">Secure online payments</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-orange-500 mr-3 mt-1" />
                  <span className="text-lg">Transparent commission</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-orange-500 mr-3 mt-1" />
                  <span className="text-lg">Admin verification</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-orange-500 mr-3 mt-1" />
                  <span className="text-lg">Support available</span>
                </li>
              </ul>
            </div>

            {/* Get Started */}
            <div>
              <h2 className="text-3xl font-bold mb-6 text-blue-800">Get Started</h2>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <span className="bg-orange-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3 font-bold">1</span>
                  <span className="text-lg">Install CoSpace App</span>
                </li>
                <li className="flex items-start">
                  <span className="bg-orange-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3 font-bold">2</span>
                  <span className="text-lg">Register</span>
                </li>
                <li className="flex items-start">
                  <span className="bg-orange-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3 font-bold">3</span>
                  <span className="text-lg">Add or search space</span>
                </li>
                <li className="flex items-start">
                  <span className="bg-orange-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3 font-bold">4</span>
                  <span className="text-lg">Book & pay securely</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer style={{ backgroundColor: '#003d66' }} className="text-white py-8">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <div className="mb-4">
            <h3 className="text-2xl font-bold mb-2">CoSpace</h3>
            <p>Most CoSpace Serenity</p>
          </div>
          <div className="space-y-2">
            <p>App: www.cospace.in</p>
            <p>Phone: (040) 1234 5678</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
